import { Link } from 'react-router-dom'

const ActiveTabStatus = ({ activeTab, day ,time }) => {
    return (
        <div className="text-center py-12 bg-white rounded-lg shadow-sm">
            <div className="text-6xl mb-4">
                {activeTab === 'upcoming' ? '📅' :
                    activeTab === 'completed' ? '✅' : '❌'}
            </div>
            <h3 className="text-xl font-semibold text-gray-600 mb-2">
                {activeTab === 'upcoming' ? `لا توجد حجوزات ${day + " " + time} ` :
                    activeTab === 'completed' ? 'لا توجد حجوزات مكتملة' :
                        'لا توجد حجوزات ملغية'}
            </h3>
            <p className="text-gray-500 mb-6">
                {activeTab === 'upcoming' ? 'ابدأ في حجز موعد طبي الأولى!' :
                    activeTab === 'completed' ? 'لم تكمل أي موعد بعد' :
                        'لم تلغِ أي حجوزات'}
            </p>
            {activeTab === 'upcoming' && (
                <Link
                    to="/doctors"
                    className="bg-primary text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-block"
                >
                    احجز موعد الآن
                </Link>
            )}

        </div>
    )
}

export default ActiveTabStatus